import i18n from '@/plugins/i18n';

const traceGraphs = () => ({
  areaCharts: [
    {
      width: '48%',
      widthInPer: '100%',
      title: i18n.global.t('cpu-average-used'),
      isTraceGraph: true,
      header: {
        title: i18n.global.t('cpu-average-used'),
        titleIcon: '',
        content: [],
        toolbar: true,
      },
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_vm_cpu_utilization',
      queryMetricType: 'readMetricsValues',
      aggregation: '/',
      aggregationNum: '100',
      childQueries: [],
      chartType: 'ApexChartArea',
      unit: '%',
      metricLabels: '',
      labelsIndex: '',
      axisLabels: {
        x: i18n.global.t(i18n.global.t('time')),
        y: i18n.global.t(i18n.global.t('percentage')),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: i18n.global.t('percentage'),
      },
    },
    {
      width: '48%',
      widthInPer: '100%',
      title: i18n.global.t('ramAvailable'),
      isTraceGraph: true,
      header: {
        title: i18n.global.t('ramAvailable'),
        titleIcon: '',
        content: [],
        toolbar: true,
      },
      chartColor: ['#1be7ff', '#6eeb83', '#e4fe1a'],
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_vm_memory_available_percentage',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartArea',
      unit: '%',
      metricLabels: '',
      labelsIndex: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('percentage'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: i18n.global.t('percentage'),
      },
    },
    {
      width: '48%',
      widthInPer: '100%',
      isTraceGraph: true,
      title: i18n.global.t('storageAvailable'),
      header: {
        title: i18n.global.t('storageAvailable'),
        titleIcon: '',
        content: [],
        toolbar: true,
      },
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_vm_filesystem_percentage_total_available',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartArea',
      unit: '%',
      metricLabels: '',
      labelsIndex: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('percentage'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: i18n.global.t('percentage'),
      },
    },
    {
      width: '48%',
      widthInPer: '100%',
      isTraceGraph: true,
      title: i18n.global.t('networkBandwidth'),
      header: {
        title: i18n.global.t('networkBandwidth'),
        titleIcon: '',
        content: [],
        toolbar: true,
      },
      chartColor: ['#564592', '#ecfa7f'],
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_vm_network_total',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartArea',
      aggregation: '/',
      aggregationNum: '1024',
      unit: 'KB/s',
      metricLabels: '',
      labelsIndex: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: 'KB/s',
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'KB/s',
      },
    },
  ],
  windowsAreaCharts: [
    {
      width: '48%',
      widthInPer: '100%',
      isTraceGraph: true,
      title: i18n.global.t('cpu-average-used'),

      header: {
        title: i18n.global.t('cpu-average-used'),
        titleIcon: '',
        content: [],
        toolbar: true,
      },
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'windows_vm_cpu_usage_percentage',
      aggregation: '/',
      aggregationNum: '100',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartArea',
      unit: '%',
      metricLabels: '',
      labelsIndex: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('percentage'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: i18n.global.t('percentage'),
      },
    },
    {
      width: '48%',
      widthInPer: '100%',
      isTraceGraph: true,
      title: i18n.global.t('ramAvailable'),
      header: {
        title: i18n.global.t('ramAvailable'),
        titleIcon: '',
        content: [],
        toolbar: true,
      },
      chartColor: ['#1be7ff', '#6eeb83', '#e4fe1a'],
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'windows_vm_memory_available_percentage',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartArea',
      unit: '%',
      metricLabels: '',
      labelsIndex: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('percentage'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: i18n.global.t('percentage'),
      },
    },
    {
      width: '48%',
      widthInPer: '100%',
      isTraceGraph: true,
      title: i18n.global.t('storageAvailable'),

      header: {
        title: i18n.global.t('storageAvailable'),
        titleIcon: '',
        content: [],
        toolbar: true,
      },
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'windows_vm_storage_available_percentage',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartArea',
      unit: '%',
      metricLabels: '',
      labelsIndex: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('percentage'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: i18n.global.t('percentage'),
      },
    },
    {
      width: '48%',
      widthInPer: '100%',
      isTraceGraph: true,
      title: i18n.global.t('networkBandwidth'),
      header: {
        title: i18n.global.t('networkBandwidth'),
        titleIcon: '',
        content: [],
        toolbar: true,
      },
      chartColor: ['#564592', '#ecfa7f'],
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'windows_vm_network_bandwidth_usage',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartArea',
      aggregation: '/',
      aggregationNum: '1024',
      unit: 'KB/s',
      metricLabels: '',
      labelsIndex: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: 'KB/s',
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'KB/s',
      },
    },
  ],
});
export default traceGraphs;
